import { createSelector, contactsLeftNavItemId, contactListsLeftNavItemId } from '../../shared';
import {
    AppState,
    LayoutState,
    isInSearchMode,
    Filter,
    Sorting,
    getActiveLeftNavItemId,
    SearchState,
    isActiveLeftNavItemDeletedItems,
} from '../../appstate';
import type { PersonaListViewModel } from '../models/PersonaListViewModel';

export const getPersonaListViewModel = createSelector<
    AppState,
    string,
    LayoutState,
    boolean,
    boolean,
    SearchState,
    PersonaListViewModel
>(
    'getPersonaListViewModel',
    [
        getActiveLeftNavItemId,
        (appState: AppState) => appState.view.layoutState,
        isInSearchMode,
        isActiveLeftNavItemDeletedItems,
        (appState: AppState) => appState.data.searchState,
    ],
    (activeLeftNavItemId, layoutState, isSearchMode, isInDeletedItems, searchState) => {
        let sorting = layoutState.sorting;
        if (isInDeletedItems) {
            sorting = layoutState.deletedItemsSorting;
        } else if (activeLeftNavItemId === contactListsLeftNavItemId) {
            sorting = layoutState.contactListsSorting;
        }

        // Override filter
        let filter = layoutState.filter;
        if (
            (isSearchMode &&
                searchState &&
                searchState.currentFolderId === contactListsLeftNavItemId) ||
            activeLeftNavItemId === contactListsLeftNavItemId
        ) {
            // Contact Lists show only PDLs
            filter = Filter.PrivateDistributionList;
        } else if (
            (isSearchMode &&
                searchState &&
                searchState.currentFolderId === contactsLeftNavItemId) ||
            activeLeftNavItemId === contactsLeftNavItemId
        ) {
            filter = Filter.HubPerson;
        }

        return {
            displayOrder: layoutState.displayOrder,
            filter: filter,
            sorting: isSearchMode ? Sorting.ByRelevance : sorting,
            listWidth: layoutState.listWidth,
        };
    }
);
